import React from 'react'
import R from 'ramda'
import {StaggeredMotion, spring} from 'react-motion'
import invariant from '../utils/invariant'

class  FlipCard  extends React.Component {

  constructor(props){
    super(props)
    this.flip = this.flip.bind(this)
    this.neverFlipped =  true
    
    this.selected = false
  }
  shouldComponentUpdate(nextProps, nextState){
    return !R.equals(this.props,nextProps) || !R.equals(this.state, nextState)
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.flipped && !this.props.flipped){
      this.neverFlipped =  false
    }
  }  
  flip(){
    if(this.neverFlipped){
      this.neverFlipped = false;
    }
    this.props.onFlip()
  }
  
  render(){
    const {style, flipped, children, more} = this.props

    if(!flipped)
    {
      return <div style={{perspective: "800px", ...style}}>
               <div key="front"
                          onClick={this.flip}>
                  {this.props.children[0]}
                </div>
              </div>
    }
    else if(more)
    {
      return <div style={{perspective: "800px", ...style}}>
               <div key="front">
                  {this.props.children[2]}
                </div>
              </div>
    }
    else
    {
      return <div style={{perspective: "800px", ...style}}>
               <div key="front">
                  {this.props.children[1]}
                </div>
              </div>
    }

  }
}



FlipCard.propTypes = {
  flipped: React.PropTypes.bool,
  onFlip: React.PropTypes.func.isRequired,
  style: React.PropTypes.object,
}

export default FlipCard



/** WEBPACK FOOTER **
 ** ./app/components/FlipCard.jsx
 **/